import component from './es-ES/component';
import globalHeader from './es-ES/globalHeader';
import menu from './es-ES/menu';
import pwa from './es-ES/pwa';
import common from './es-ES/common';
import form from './es-ES/form';
import supportChat from './es-ES/supportChat';
import builderChat from './es-ES/builderChat';
import notifications from './es-ES/notifications';
import processes from '../pages/Process/locales/es-ES';
import launchpad from '../pages/Launchpad/locales/es-ES';
import apps from '../pages/apps/locales/es-ES';
import home from '../pages/Home/locales/es-ES';
import applicationsModern from '../pages/applications-modern/locales/es-ES';
import documents from '../pages/documents/locales/es-ES';
import tasks from '../pages/tasks/locales/es-ES';
import tasksModern from '../pages/tasks-modern/locales/es-ES';
import channelOnboarding from '../pages/configurations/channel-onboarding/locales/es-ES';
import whiteLabel from '../pages/configurations/white-label/locales/es-ES';
import customDomains from '../components/CustomDomains/locales/es-ES';
import aiAgentSchedule from '../pages/administration-agents/ai-agent-work/locales/es-ES';
import rpaAgents from '../pages/administration-agents/rpa-agents/locales/es-ES';
import usage from '../pages/configurations/usage/locales/es-ES';
import reportsConfig from '../pages/configurations/reports/locales/es-ES';
import reportGroupsConfig from '../pages/configurations/report-groups/locales/es-ES';
import reportsConsume from '../pages/reports/locales/es-ES';
import financialAdministration from '../pages/configurations/financial-administration/locales/es-ES';

export default {
  'navBar.lang': 'Lenguages',
  'layout.user.link.help': 'Ayuda',
  'layout.user.link.privacy': 'Privacidad',
  'layout.user.link.terms': 'Términos',
  'app.preview.down.block': 'Descarga esta página para tu proyecto local',
  'app.welcome.link.fetch-blocks': 'Obtén todos los bloques',
  'app.welcome.link.block-list':
    'Construye rápidamente páginas estándar basadas en el desarrollo de `bloque`',
  ...globalHeader,
  ...menu,
  ...pwa,
  ...component,
  ...common,
  ...form,
  ...supportChat,
  ...builderChat,
  ...notifications,
  ...processes,
  ...launchpad,
  ...apps,
  ...home,
  ...applicationsModern,
  ...documents,
  ...tasks,
  ...tasksModern,
  ...channelOnboarding,
  ...whiteLabel,
  ...customDomains,
  ...aiAgentSchedule,
  ...rpaAgents,
  ...usage,
  ...reportsConfig,
  ...reportGroupsConfig,
  ...reportsConsume,
  ...financialAdministration,
};
